import {FirestoreDocSnapshotWithIdAndData, mapFirestoreTimestampToDateForObjectValue} from '@coolcolduk/firebase-util';
import {May, WithId} from '@coolcolduk/typescript-util';
import {mapFirestoreDocToObjectTypeUndefined} from './mapFirestoreDocToObjectTypeUndefined';

/**
 * Map a Firestore document snapshot to an object with id and timestamp to date.
 * @param firestoreObject - The Firestore document snapshot.
 * @returns The object with id and timestamp to date.
 * @deprecated move to @coolcolduk/firebase-util
 */
export function mapFirestoreDocWithTimestamp<T = Record<string, unknown>, R = WithId<T>>(
  firestoreObject?: FirestoreDocSnapshotWithIdAndData<T> | null | undefined,
): May<R> {
  const data = mapFirestoreDocToObjectTypeUndefined(firestoreObject);
  return data ? mapFirestoreTimestampToDateForObjectValue(data) : undefined;
}
